import React, { useEffect } from 'react';
import { Link as Redirect, withRouter } from 'react-router-dom';
//
import PropTypes from 'prop-types';
//
import List from './List';


function Peloton() {

  return (
    <>
      <List />
    </>
  )
}

Peloton.propTypes = {
  history: PropTypes.object
};
export default withRouter(Peloton)

